import { render, staticRenderFns } from "./DynamicTopicList.vue?vue&type=template&id=637f774d&scoped=true"
import script from "./DynamicTopicList.vue?vue&type=script&lang=js"
export * from "./DynamicTopicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f774d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637f774d')) {
      api.createRecord('637f774d', component.options)
    } else {
      api.reload('637f774d', component.options)
    }
    module.hot.accept("./DynamicTopicList.vue?vue&type=template&id=637f774d&scoped=true", function () {
      api.rerender('637f774d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/dynamic/DynamicTopicList.vue"
export default component.exports